import React from "react";
import Bannerheader from "../pages/Bannerheader";
import { Footer } from "../navbar/Footer";

const TermsConditions = () => {
  return (
    <>
      <Bannerheader />

      {/* Document Style Container */}
      <div className="bg-light py-4">
        <div className="container">
          {/* Document Paper Effect */}
          <div className="bg-white shadow rounded-3 overflow-hidden">
            {/* Document Header */}
            <div className="border-bottom p-4 p-md-5 text-center bg-secondary bg-opacity-10">
              <div className="mb-3">
                <span className="bg-secondary text-white px-3 py-2 rounded-3 fw-semibold small">
                  LEGAL AGREEMENT
                </span>
              </div>
              <h1 className="display-5 fw-bold text-dark mb-3">
                Terms & Conditions
              </h1>
            </div>

            {/* Document Content */}
            <div className="p-4 p-md-5">
              {/* Introduction / Acceptance */}
              <div className="mb-5">
                <div className="bg-secondary bg-opacity-5 p-4 rounded-3 border-start border-secondary border-4">
                  <p className="lead text-secondary mb-3">
                    Welcome to Vogelkop Architects. These Terms and Conditions
                    govern your use of our website and the purchase of our
                    products.
                  </p>
                  <p className="text-secondary mb-0">
                    By accessing or using our website, you agree to be bound by
                    these Terms. If you disagree with any part, please do not
                    use our services.
                  </p>
                </div>
              </div>

              {/* Table of Contents */}
              <div className="mb-5">
                <h6 className="fw-bold mb-3 text-uppercase small text-secondary">
                  Quick Navigation
                </h6>
                <div className="row g-2">
                  <div className="col-md-3 col-6">
                    <a
                      href="#section1"
                      className="text-decoration-none text-secondary d-block p-2 hover-bg-light rounded"
                    >
                      1. Introduction
                    </a>
                  </div>
                  <div className="col-md-3 col-6">
                    <a
                      href="#section2"
                      className="text-decoration-none text-secondary d-block p-2 hover-bg-light rounded"
                    >
                      2. Products
                    </a>
                  </div>
                  <div className="col-md-3 col-6">
                    <a
                      href="#section3"
                      className="text-decoration-none text-secondary d-block p-2 hover-bg-light rounded"
                    >
                      3. Orders
                    </a>
                  </div>
                  <div className="col-md-3 col-6">
                    <a
                      href="#section4"
                      className="text-decoration-none text-secondary d-block p-2 hover-bg-light rounded"
                    >
                      4. Pricing
                    </a>
                  </div>
                  <div className="col-md-3 col-6">
                    <a
                      href="#section5"
                      className="text-decoration-none text-secondary d-block p-2 hover-bg-light rounded"
                    >
                      5. Payments
                    </a>
                  </div>
                  <div className="col-md-3 col-6">
                    <a
                      href="#section6"
                      className="text-decoration-none text-secondary d-block p-2 hover-bg-light rounded"
                    >
                      6. Shipping
                    </a>
                  </div>
                  <div className="col-md-3 col-6">
                    <a
                      href="#section7"
                      className="text-decoration-none text-secondary d-block p-2 hover-bg-light rounded"
                    >
                      7. Returns
                    </a>
                  </div>
                  <div className="col-md-3 col-6">
                    <a
                      href="#section8"
                      className="text-decoration-none text-secondary d-block p-2 hover-bg-light rounded"
                    >
                      8. Liability
                    </a>
                  </div>
                </div>
              </div>

              {/* Section 1 - Introduction */}
              <section id="section1" className="mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="bg-secondary text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: "42px", height: "42px", flexShrink: 0 }}
                  >
                    <span className="fw-bold">1</span>
                  </div>
                  <h2 className="h4 fw-bold mb-0">Introduction</h2>
                </div>

                <div className="ps-md-5">
                  <p className="text-secondary mb-3">
                    By accessing and using Vogelkop Architects website, you
                    agree to comply with these Terms & Conditions. These terms
                    apply to all users, visitors, and customers of our website.
                  </p>

                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="border rounded-3 p-3">
                        <i className="bi bi-check-circle-fill text-success mb-2 d-block"></i>
                        <h6 className="fw-bold mb-2">Your Acceptance</h6>
                        <p className="small text-secondary mb-0">
                          Using our website constitutes acceptance of these
                          terms and conditions.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="border rounded-3 p-3">
                        <i className="bi bi-exclamation-triangle-fill text-warning mb-2 d-block"></i>
                        <h6 className="fw-bold mb-2">Updates</h6>
                        <p className="small text-secondary mb-0">
                          We reserve the right to modify these terms at any time
                          without prior notice.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {/* Section 2 - Products */}
              <section id="section2" className="mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: "42px", height: "42px", flexShrink: 0 }}
                  >
                    <span className="fw-bold">2</span>
                  </div>
                  <h2 className="h4 fw-bold mb-0">Products</h2>
                </div>

                <div className="ps-md-5">
                  <p className="text-secondary mb-3">
                    We specialize in selling high-quality furniture products.
                    The following terms apply to our products:
                  </p>

                  <ul className="list-group list-group-flush mb-3">
                    <li className="list-group-item bg-transparent px-0">
                      <i className="bi bi-dot text-primary me-2"></i>
                      Product descriptions and specifications are provided for
                      informational purposes
                    </li>
                    <li className="list-group-item bg-transparent px-0">
                      <i className="bi bi-dot text-primary me-2"></i>
                      Colors and finishes may vary slightly from images due to
                      monitor settings
                    </li>
                    <li className="list-group-item bg-transparent px-0">
                      <i className="bi bi-dot text-primary me-2"></i>
                      We reserve the right to discontinue products without
                      notice
                    </li>
                    <li className="list-group-item bg-transparent px-0">
                      <i className="bi bi-dot text-primary me-2"></i>
                      Product availability is subject to stock levels
                    </li>
                  </ul>

                  <div className="bg-warning bg-opacity-10 p-3 rounded-3">
                    <small className="text-warning-dark">
                      <i className="bi bi-info-circle me-2"></i>
                      All product descriptions and prices are subject to change
                      without notice.
                    </small>
                  </div>
                </div>
              </section>

              {/* Section 3 - Orders */}
              <section id="section3" className="mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="bg-info text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: "42px", height: "42px", flexShrink: 0 }}
                  >
                    <span className="fw-bold">3</span>
                  </div>
                  <h2 className="h4 fw-bold mb-0">Orders</h2>
                </div>

                <div className="ps-md-5">
                  <div className="row">
                    <div className="col-lg-8">
                      <p className="text-secondary mb-3">
                        We reserve the right to cancel or refuse any order at
                        our discretion under the following circumstances:
                      </p>

                      <table className="table table-bordered">
                        <thead className="table-light">
                          <tr>
                            <th>Reason</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Product unavailable</td>
                            <td>Order cancelled with full refund</td>
                          </tr>
                          <tr>
                            <td>Suspected fraud</td>
                            <td>Order held for verification</td>
                          </tr>
                          <tr>
                            <td>Pricing error</td>
                            <td>Order cancelled or adjusted</td>
                          </tr>
                          <tr>
                            <td>Shipping restrictions</td>
                            <td>Order cancelled with notification</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="col-lg-4">
                      <div className="card bg-light border-0">
                        <div className="card-body text-center">
                          <i className="bi bi-cart-x fs-1 text-secondary mb-2"></i>
                          <h6 className="fw-bold">Order Cancellation</h6>
                          <p className="small text-secondary mb-0">
                            We'll notify you immediately if your order is
                            cancelled and process refunds promptly.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {/* Section 4 - Pricing */}
              <section id="section4" className="mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: "42px", height: "42px", flexShrink: 0 }}
                  >
                    <span className="fw-bold">4</span>
                  </div>
                  <h2 className="h4 fw-bold mb-0">Pricing</h2>
                </div>

                <div className="ps-md-5">
                  <p className="text-secondary mb-3">
                    All prices are listed in{" "}
                    <strong>Indian Rupees (INR)</strong> and are subject to the
                    following:
                  </p>

                  <div className="row g-3">
                    <div className="col-md-4">
                      <div className="border rounded-3 p-3 text-center">
                        <i className="bi bi-tag fs-2 text-success mb-2"></i>
                        <h6 className="fw-bold">Base Price</h6>
                        <p className="small text-secondary mb-0">
                          Product price before taxes
                        </p>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="border rounded-3 p-3 text-center">
                        <i className="bi bi-receipt fs-2 text-success mb-2"></i>
                        <h6 className="fw-bold">GST</h6>
                        <p className="small text-secondary mb-0">
                          18% GST applicable on all products
                        </p>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="border rounded-3 p-3 text-center">
                        <i className="bi bi-truck fs-2 text-success mb-2"></i>
                        <h6 className="fw-bold">Shipping</h6>
                        <p className="small text-secondary mb-0">
                          Calculated at checkout based on location
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="mt-3 bg-light p-3 rounded-3">
                    <p className="small text-secondary mb-0">
                      <i className="bi bi-info-circle me-2 text-primary"></i>
                      Prices are subject to change without notice. However, once
                      an order is confirmed, the price is locked.
                    </p>
                  </div>
                </div>
              </section>

              {/* Section 5 - Payments */}
              <section id="section5" className="mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="bg-warning text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: "42px", height: "42px", flexShrink: 0 }}
                  >
                    <span className="fw-bold">5</span>
                  </div>
                  <h2 className="h4 fw-bold mb-0">Payment Terms</h2>
                </div>

                <div className="ps-md-5">
                  <ul className="list-unstyled">
                    <li className="mb-2 d-flex">
                      <i className="bi bi-check-circle-fill text-success me-2"></i>
                      Full payment is required at the time of order
                    </li>
                    <li className="mb-2 d-flex">
                      <i className="bi bi-check-circle-fill text-success me-2"></i>
                      We accept payments via Razorpay (Credit/Debit Cards, UPI,
                      NetBanking, Wallets)
                    </li>
                    <li className="mb-2 d-flex">
                      <i className="bi bi-check-circle-fill text-success me-2"></i>
                      All transactions are secure and encrypted
                    </li>
                    <li className="mb-2 d-flex">
                      <i className="bi bi-check-circle-fill text-success me-2"></i>
                      Payment confirmation required before order processing
                    </li>
                  </ul>
                </div>
              </section>

              {/* Section 6 - Shipping */}
              <section id="section6" className="mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: "42px", height: "42px", flexShrink: 0 }}
                  >
                    <span className="fw-bold">6</span>
                  </div>
                  <h2 className="h4 fw-bold mb-0">Shipping & Delivery</h2>
                </div>

                <div className="ps-md-5">
                  <div className="row">
                    <div className="col-md-6">
                      <h6 className="fw-bold mb-2">Domestic Shipping</h6>
                      <ul className="text-secondary">
                        <li>Free shipping on orders above ₹50,000</li>
                        <li>Standard delivery: 5-7 business days</li>
                        <li>Express delivery available at extra cost</li>
                      </ul>
                    </div>
                    <div className="col-md-6">
                      <h6 className="fw-bold mb-2">Important Notes</h6>
                      <ul className="text-secondary">
                        <li>Signature required upon delivery</li>
                        <li>Inspect items before accepting</li>
                        <li>Report damages within 24 hours</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </section>

              {/* Section 7 - Returns */}
              <section id="section7" className="mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: "42px", height: "42px", flexShrink: 0 }}
                  >
                    <span className="fw-bold">7</span>
                  </div>
                  <h2 className="h4 fw-bold mb-0">Return & Refund Policy</h2>
                </div>

                <div className="ps-md-5">
                  <p className="text-secondary mb-3">
                    Returns are accepted subject to our Return Policy. Key terms
                    include:
                  </p>
                  <ul>
                    <li>7-day return window for damaged/defective items</li>
                    <li>Customized furniture non-returnable</li>
                    <li>Refunds processed within 7-10 business days</li>
                    <li>Original condition required for returns</li>
                  </ul>
                  <div className="mt-2">
                    <a
                      href="/return-refund-policy"
                      className="text-decoration-none"
                    >
                      View Full Return Policy{" "}
                      <i className="bi bi-arrow-right"></i>
                    </a>
                  </div>
                </div>
              </section>

              {/* Section 8 - Limitation of Liability */}
              <section id="section8" className="mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="bg-dark text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: "42px", height: "42px", flexShrink: 0 }}
                  >
                    <span className="fw-bold">8</span>
                  </div>
                  <h2 className="h4 fw-bold mb-0">Limitation of Liability</h2>
                </div>

                <div className="ps-md-5">
                  <div className="card border-danger">
                    <div className="card-body">
                      <p className="text-secondary mb-3">
                        To the maximum extent permitted by law, Vogelkop
                        Architects shall not be liable for:
                      </p>
                      <ul className="text-secondary">
                        <li className="mb-2">
                          Any indirect, incidental, or consequential damages
                        </li>
                        <li className="mb-2">
                          Loss of profits, data, or business opportunities
                        </li>
                        <li className="mb-2">
                          Damages arising from use or inability to use our
                          products
                        </li>
                        <li className="mb-2">Third-party claims against you</li>
                      </ul>
                      <div className="bg-light p-3 rounded-3 mt-3">
                        <small className="text-secondary">
                          <i className="bi bi-exclamation-triangle me-2 text-danger"></i>
                          Our total liability shall not exceed the amount paid
                          by you for the products purchased.
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {/* Section 9 - Intellectual Property */}
              <section className="mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="bg-secondary text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: "42px", height: "42px", flexShrink: 0 }}
                  >
                    <span className="fw-bold">9</span>
                  </div>
                  <h2 className="h4 fw-bold mb-0">Intellectual Property</h2>
                </div>

                <div className="ps-md-5">
                  <p className="text-secondary">
                    All content on this website, including images, text, logos,
                    and designs, is the property of Vogelkop Architects and
                    protected by copyright laws. Unauthorized use is strictly
                    prohibited.
                  </p>
                </div>
              </section>

              {/* Section 10 - Governing Law */}
              <section className="mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="bg-secondary text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: "42px", height: "42px", flexShrink: 0 }}
                  >
                    <span className="fw-bold">10</span>
                  </div>
                  <h2 className="h4 fw-bold mb-0">Governing Law</h2>
                </div>

                <div className="ps-md-5">
                  <p className="text-secondary">
                    These Terms shall be governed by and construed in accordance
                    with the laws of India. Any disputes arising under these
                    Terms shall be subject to the exclusive jurisdiction of the
                    courts in Bangalore.
                  </p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>

      {/* Bootstrap Icons */}
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css"
      />

      {/* Custom Styles */}
      <style jsx>{`
        .bg-opacity-5 {
          background-color: rgba(var(--bs-secondary-rgb), 0.05) !important;
        }
        .hover-bg-light:hover {
          background-color: #f8f9fa;
          transition: all 0.2s ease;
        }
      `}</style>

      <Footer />
    </>
  );
};

export default TermsConditions;
